import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError, switchMap, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { AuthService } from "../../../shared/services/auth/auth.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  static accessToken: string = "";

  constructor(private authService: AuthService) {}

  // intercept(
  //   request: HttpRequest<unknown>,
  //   next: HttpHandler
  // ): Observable<HttpEvent<unknown>> {
  //   AuthInterceptor.accessToken = this.authService.getAccessToken();
  //   const isSessionActive = this.authService.isSessionActive();

  //   const svgNotToken =
  //     request.url.includes("assets/") &&
  //     (!AuthInterceptor.accessToken || !isSessionActive);

  //   if (request.url === environment.baseURLRealMS || svgNotToken) {
  //     return next.handle(request).pipe(
  //       catchError((err: HttpErrorResponse) => {
  //         if (err.status === 401) {
  //           return this.authService.autorization().pipe(
  //             delay(3000),
  //             switchMap((res) => {
  //               AuthInterceptor.accessToken = res.access_token;
  //               return next.handle(req);
  //             })
  //           );
  //         }

  //         return throwError(() => err);
  //       })
  //     );
  //   }

  //   // if (request.url.includes('assets/') && (!AuthInterceptor.accessToken && !isSessionActive)) {
  //   // 	return next.handle(request);
  //   // }

  //   const req = request.clone({
  //     setHeaders: {
  //       Authorization: `Bearer ${AuthInterceptor.accessToken}`,
  //     },
  //   });

  //   if (AuthInterceptor.accessToken && isSessionActive) {
  //     return next.handle(req).pipe(
  //       catchError((err: HttpErrorResponse) => {
  //         if (err.status == 401) {
  //           return this.authService.autorization().pipe(
  //             switchMap((res) => {
  //               AuthInterceptor.accessToken = res.access_token;
  //               return next.handle(req);
  //             })
  //           );
  //         }

  //         return throwError(() => err);
  //       })
  //     );
  //   } else {
  //     return this.authService.autorization().pipe(
  //       switchMap((res) => {
  //         AuthInterceptor.accessToken = res.access_token;

  //         return next.handle(req);
  //       })
  //     );
  //   }
  // }
  	intercept(
		request: HttpRequest<unknown>,
		next: HttpHandler
	): Observable<HttpEvent<unknown>> {
		AuthInterceptor.accessToken = this.authService.getAccessToken();
		const isSessionActive = this.authService.isSessionActive();


		const isAutorizationAPI = request.url === environment.baseURLRealMS;

		if (this.authService.checkValidSession() && !isAutorizationAPI) {
			const req = request.clone({
				setHeaders: {
					Authorization: `Bearer ${AuthInterceptor.accessToken}`
				},
			});
			return next.handle(req);

		} else {

			return next.handle(request).pipe(
				catchError((err: HttpErrorResponse) => {
					if (err.status == 401 && !isAutorizationAPI) {
						return this.authService.autorization().pipe(

							switchMap((res) => {
									AuthInterceptor.accessToken = res.access_token;
									const req = request.clone({
										setHeaders: {
											Authorization: `Bearer ${AuthInterceptor.accessToken}`
										},
									});
									return next.handle(req);
								}
							)
						);
					} else {
						return throwError(() => err);
					}
				}
			)
		);
		}
	}
}
